var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3DCubeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 13.6251V10.7084C2.91675 6.33341 5.83341 3.41675 10.2084 3.41675H24.7917C29.1667 3.41675 32.0834 6.33341 32.0834 10.7084V13.6251",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 13.6251V10.7084C2.91675 6.33341 5.83341 3.41675 10.2084 3.41675H24.7917C29.1667 3.41675 32.0834 6.33341 32.0834 10.7084V13.6251",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 22.375V25.2917C2.91675 29.6667 5.83341 32.5833 10.2084 32.5833H24.7917C29.1667 32.5833 32.0834 29.6667 32.0834 25.2917V22.375",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77075 14.0042L17.4999 18.4812L25.1707 14.0333",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 26.4145V18.4666",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6917 9.6729L11.0251 12.2688C9.97509 12.8521 9.1001 14.325 9.1001 15.5354V20.4792C9.1001 21.6896 9.9605 23.1625 11.0251 23.7459L15.6917 26.3416C16.6834 26.8958 18.3168 26.8958 19.323 26.3416L23.9897 23.7459C25.0397 23.1625 25.9147 21.6896 25.9147 20.4792V15.5354C25.9147 14.325 25.0543 12.8521 23.9897 12.2688L19.323 9.6729C18.3168 9.10415 16.6834 9.10415 15.6917 9.6729Z",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DCubeIcon);
export default __webpack_public_path__ + "static/media/3d-cube-icon.3d26d83a1dd789c1691407b4d2e66cb4.svg";
export { ForwardRef as ReactComponent };